import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	AuthDeleteRequest as Req,
	AuthDeleteResponse as Res,
} from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/DELETE";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { AuthFromDtoDelete as Dto } from "src/business.InterfaceLayer/store/entities/auth.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import { AUTH_FIELDS } from "../../fields";

const deleteRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.DELETE,
	MAIN_PATHS.USER
);

const authApiDeleteQueries = (build: ApiQueryBuilder) => ({
	deleteAccount: build.mutation<Nullable<Res.AuthDelete>, Req.AuthDelete>({
		query: ({ [AUTH_FIELDS.ID]: id }) => ({
			...deleteRequestBaseDefinition({ path: `/${id}` }),
		}),
		transformResponse: Dto.authDeleteAccountFromDto,
	}),
});

export default authApiDeleteQueries;
